<template>
  <nav class="navbar is-primary is-fixed-top" role="navigation" aria-label="main navigation">

    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <!-- <img src="https://bulma.io/images/bulma-logo.png" alt="Bulma: a modern CSS framework based on Flexbox" width="112" height="28"> -->
        <span>SSR-Leiden</span>
      </router-link>
      <div class="navbar-burger burger" data-target="navbarExampleTransparentExample">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="navbar-menu">
      <div class="navbar-start">
        <div class="navbar-item" v-if="isLoggedIn">
          <div class="is-field">
            <p class="control">
              <router-link class="button is-primary" to="/calendar">
                <b-icon icon="calendar" size="is-small"></b-icon>
                <span>Kalender</span>
              </router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="navbar-end">
        <div class="navbar-item" v-if="isLoggedIn">
          <div class="is-field">
            <p class="control">
              <router-link class="button is-primary" to="/settings">
                <b-icon icon="settings" size="is-small"></b-icon>
                <span>Instellingen</span>
              </router-link>
              <a class="button is-primary" @click="logout">
                <b-icon icon="logout" size="is-small"></b-icon>
                <span>Uitloggen</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'isAdmin',
    ])
  },
  methods: {
    logout() {
      // update store
      this.$store.dispatch('logout', this.$store.getters.requestAuth)
        .then(() => {
          this.deleteCookies();
          this.$router.push('/');
        })
        .catch();
    },

    deleteCookie(name) {
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    deleteCookies() {
      let _this = this;
      const arr = ['uid', 'hash', 'expires'];

      arr.forEach(function(val) {
        _this.deleteCookie(val);
      });
    }
  },
  created() {

  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue